import React from 'react'
import { ContentWrapperStoryblok } from '@/components/component-types-sb';
import { SbEditableContent } from 'storyblok-react';
import SbEditable from 'storyblok-react';
import DynamicComponent from '@/components/DynamicComponent';

export const ContentWrapper = ({ blok }: ContentWrapperStoryblok) => {
  const paddingTopClass = blok.paddingTop ? `${blok.paddingTop}px` : ''
  const paddingBottomClass = blok.paddingBottom ? `${blok.paddingBottom}px` : ''  

  return (
    <div
    className={`bg-no-repeat ${blok?.backgroundCover ? 'lg:bg-cover' : 'bg-contain'}`}
    style={{
      backgroundAttachment: 'unset',
      backgroundImage: `url('${blok?.backgroundImage?.filename}')`,
      backgroundColor: blok?.backgroundColour,
      backgroundPosition: 'top center',
      paddingTop: paddingTopClass,
      paddingBottom: paddingBottomClass,
    }}
    >
        {/** @ts-ignore: Storyblok typing issue with children **/}
        <SbEditable content={blok} key={blok._uid}>
          {blok.content &&
            blok.content.map((childBlok: SbEditableContent) => (
              <DynamicComponent blok={childBlok} key={childBlok._uid} page={null} />
          ))}
        </SbEditable>
    </div>        
  )
}

ContentWrapper.displayName = 'Content wrapper'